import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import useParams from '@components/Hooks/useParams';
import Termite from '@divtel/termite';
import Fader from '@Shared/Fader';
import Paginator from '@Shared/Paginator';
import { ISearchResult } from '@src/interfaces';
import React, { useEffect, useState } from 'react';
import { Container as Grid, Form, ListGroup } from 'react-bootstrap';
import SearchResult from './Result';


const Search: React.FC = () => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const [page, setPage] = useState<number>(1);
  const params = useParams();

  useEffect(() => {
    api.getSearch(params.type ?? '', page, params.terms ?? '');
  }, [])

  const getPageCount = () => {
    return Math.max(Math.ceil((store.search?.count ?? 0) / 10), 1);
  }

  const updatePage = (num: number): void => {
    api.getSearch(params.type ?? '', num, params.terms ?? '');
    setPage(num);
  }

  return (
    // @ts-ignore
    <Termite app='Search Results'>
      <div className='main-section'>
        <Grid style={{ paddingTop: 44 }}>
          <h2>Finding {'"' + params.terms + '"'} in {params.type}</h2>
          <Form.Group style={{ paddingTop: 21 }} className='form-group'>
            <Paginator
              totalPages={getPageCount()}
              currentPage={Math.min(page, getPageCount())}
              onChange={updatePage}
            />
          </Form.Group>
          <Form.Group className='form-group'>
            <Fader>
              {!!store.search && (
                <ListGroup
                  className={'icon-list ' + (store.search?.count ? 'light-shadow' : '')}
                >
                  {store.search?.nodes?.map((result: ISearchResult) => {
                    return (
                      <SearchResult key={result.id} result={result} />
                    )
                  })}
                </ListGroup>
              )}
            </Fader>
          </Form.Group>
        </Grid>
      </div>
    </Termite>
  );
}

export default Search;